<template>
  <div class="means">
    <table class="mailTable" cellspacing="0" cellpadding="0">
      <tr>
        <td class="column">产品名称</td>
        <td>{{ productParticulars.fundName }}</td>
      </tr>
      <tr>
        <td class="column">产品代码</td>
        <td>{{ productParticulars.fundCode }}</td>
      </tr>
      <tr>
        <td class="column">投资类型</td>
        <td>{{ productParticulars.investType_dictText }}</td>
      </tr>
      <tr>
        <td class="column">产品风险</td>
        <td>{{ productParticulars.riskLevel_dictText }}</td>
      </tr>
      <tr>
        <td class="column">产品性质</td>
        <td>{{ productParticulars.proNature_dictText }}</td>
      </tr>
      <tr>
        <td class="column">是否母产品</td>
        <td>{{ productParticulars.isParent == 1 ? '是' : '否' }}</td>
      </tr>
      <tr>
        <td class="column">成立日</td>
        <td>{{ productParticulars.setupDate }}</td>
      </tr>
      <tr>
        <td class="column">创建时间</td>
        <td>{{ productParticulars.createTime }}</td>
      </tr>
      <tr>
        <td class="column">更新时间</td>
        <td>{{ productParticulars.updateTime }}</td>
      </tr>
      <tr>
        <td class="column">审核状态</td>
        <td v-if="productParticulars.isReview == 0">未审核</td>
        <td v-else>已审核</td>
      </tr>
      <tr v-for="item in formItemList" :key="item.value">
        <td class="column">{{ item.title }}</td>
        <td v-html="item.text"></td>
      </tr>
    </table>
  </div>
</template>
<script>
import { getSummaryByCode } from '@/api/product';
import { postAction } from '@/api/manage';

export default {
  data() {
    return {
      productParticulars: {}, //产品信息
      formItemList: [],
      summaryList: [],
      url: {
        summayry: process.env.VUE_APP_CMS_PRODUCT + '/product/fund/summary/dict'
      }
    };
  },
  watch: {
    summaryList(val) {
      this.handleSummaryInfo();
    }
  },
  mounted() {
    this.initData();
    this.ajaxGetDictItemsMessage();
    this.productParticulars = JSON.parse(
      sessionStorage.getItem('productParticulars')
    );
  },
  methods: {
    initData() {
      let formdata = new FormData();
      formdata.append('fundId', this.$route.query.fundId);
      getSummaryByCode(formdata).then(res => {
        if (res.success) {
          this.summaryList = res.result ? res.result : [];
        }
      });
    },
    async ajaxGetDictItemsMessage() {
      //  postAction(this.url.summayry).then(res => {
      //   if (res.success) {
      //     this.formItemList = res.result ? res.result : [];
      //   } else {
      //     this.$message.error(res.message);
      //   }
      // });
      postAction(this.url.summayry).then(res => {
        if (res.success) {
          this.formItemList = res.result ? res.result : [];
          this.formItemList.forEach(item => {
            item.text = '';
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleSummaryInfo() {
      this.summaryList.forEach(item => {
        let obj = this.formItemList.find(ele => ele.value == item.summaryCode);
        obj.text = item.content;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.means {
  padding: 20px 0;
}
.mailTable {
  width: 100%;
  border-top: 1px solid #e6eaee;
  border-left: 1px solid #e6eaee;
}
.mailTable tr td {
  width: 200px;
  height: 54px;
  line-height: 54px;
  box-sizing: border-box;
  padding: 0 10px;
  border-bottom: 1px solid #e6eaee;
  border-right: 1px solid #e6eaee;
}
.mailTable tr td.column {
  background-color: #fafafa;
  color: #393c3e;
  width: 30%;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
}
</style>
